"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNewsletterLoader = exports.renderComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const webexUI_1 = require("webexUI");
const ModalDialog_1 = require("Views/Partials/Components/ModalDialog");
const SignUpFormStatusMessage_1 = require("Views/Partials/Components/SignUp/components/SignUpFormStatusMessage");
const NewsletterGtm_1 = require("./components/NewsletterGtm");
exports.renderComponent = {
    Form: (signUpTypes, apiUrl, hashMapTypes, reCaptchaSiteKey, bypassRecaptchaKey, render, control, pageId) => ((0, jsx_runtime_1.jsx)(NewsletterGtm_1.NewsletterFormGtm, { items: signUpTypes.formItems, inputObject: signUpTypes.inputObject, pageId: pageId, apiUrl: apiUrl, renderSpinner: render.renderSpinner, renderMessage: render.renderMessage, control: control, additionalFormData: hashMapTypes.additionalFormData, reCaptchaSiteKey: reCaptchaSiteKey, bypassRecaptchaKey: bypassRecaptchaKey })),
    NewsletterMessage: (message, buttonLabel) => ((0, jsx_runtime_1.jsx)(SignUpFormStatusMessage_1.SignUpFormStatusMessage, { message: message, buttonLabel: buttonLabel, close: close })),
    NewsletterSpinner: (0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { visible: true }),
};
const renderNewsletterLoader = (component, selector, title, classes, popupAriaLabel, closeButtonAriaLabel, onModalClose) => {
    const additionalModalParameters = {
        classes,
        onModalClose,
        popupAriaLabel,
        closeButtonAriaLabel,
        backdrop: 'static',
    };
    (0, ModalDialog_1.RenderModal)(component, selector, title, additionalModalParameters);
};
exports.renderNewsletterLoader = renderNewsletterLoader;
